import { render, staticRenderFns } from "./MaterialProcurement.vue?vue&type=template&id=2b48eb64&scoped=true"
import script from "./MaterialProcurement.vue?vue&type=script&lang=js"
export * from "./MaterialProcurement.vue?vue&type=script&lang=js"
import style0 from "./MaterialProcurement.vue?vue&type=style&index=0&id=2b48eb64&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b48eb64",
  null
  
)

export default component.exports